import {
  FETCH_ALL_ACTIVITIES_FAILURE,
  FETCH_ALL_ACTIVITIES_REQUEST,
  FETCH_ALL_ACTIVITIES_SUCCESS,
} from '../actions/activity';

const initialState = {
  // activities: {
  //   results: [],
  // },
  allActivities: {
    results: [],
  },
  errors: null,
  hasFetchedActivities: false,
  isActivitiesFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_ACTIVITIES_REQUEST:
      return {
        ...state,
        isActivitiesFetching: true,
      };
    case FETCH_ALL_ACTIVITIES_SUCCESS:
      return {
        ...state,
        allActivities: action.payload,
        errors: null,
        hasFetchedActivities: true,
        isActivitiesFetching: false,
      };
    case FETCH_ALL_ACTIVITIES_FAILURE:
      return {
        ...state,
        allActivities: {
          ...state.allActivities,
          results: [],
        },
        errors: action.payload,
        hasFetchedActivities: true,
        isActivitiesFetching: false,
      };
    default:
      return state;
  }
};
